const Messages = {
  requestAuthTokens: { key: "dataRequest", value: "legacyAuthTokensPayload" },
  requestLogout: { key: "actionRequest", value: "closeSession" },
};

export default Messages;
